import PropTypes from 'prop-types'

import { PlotByToggle } from '@aytm/app/stats/page/question-views/bpm/components/tv/Controls'

// What the topography sub-mode says about itself: which of the two things it is plotting.
const TvHeader = ({ tvPlotByValue, defaultValues, onModelChange }) => (
  <PlotByToggle tvPlotByValue={tvPlotByValue} defaultValues={defaultValues.t} onModelChange={onModelChange} />
)

TvHeader.displayName = 'BpmTvHeader'

TvHeader.propTypes = {
  tvPlotByValue: PropTypes.string,
  defaultValues: PropTypes.object,
  onModelChange: PropTypes.func
}

export default TvHeader
